import { FaLocationDot } from "react-icons/fa6";
import { BillingMirrorCart } from "./BillingMirrorCart";
import { useCallback, useMemo } from "react";
import NoCartDataFound from "../NoCartDataFound";

interface Props {
  cartData: any;
   scrollRef?: React.RefObject<HTMLDivElement>;
   hasMembership:boolean
}

const BillingMirrorItems = ({cartData,scrollRef,hasMembership}:Props) => {

  const isActiveItem = useCallback((item: any) => {
    const qty = Number(item?.quantity ?? item?.qty ?? 0);
    const availability = (item?.availability ?? "").toLowerCase();
    return qty > 0 && availability !== "unavailable";
  }, []);

  const carts = useMemo(() => {
    if (!cartData) return [];

    const petCarts =
      cartData?.pets
        ?.filter((p: any) => p.items?.length > 0)
        .map((p: any) => ({
          type: "pet",
          title: `${p.pet_name?.toUpperCase()}'S CART`,
          items: p.items?.filter(isActiveItem) ?? [],
          pet_species: p.pet_species,
        })) || [];

    const filteredPetCarts = petCarts.filter((cart) => cart.items?.length > 0);

    const hdItems = cartData?.hd_cart?.main_cart_items?.filter(isActiveItem) ?? [];

    const hdCart =
      hdItems.length > 0
        ? [
            {
              type: "delivery",
              title: "HOME DELIVERY",
              items: hdItems,
            },
          ]
        : [];

    return [...filteredPetCarts, ...hdCart];
  }, [cartData, isActiveItem]);

  const location =
    cartData?.hd_cart?.address?.address_2

  const hasPetItems = cartData?.pets?.some((pet) => pet?.items?.some(isActiveItem));

  const hasHdItems = cartData?.hd_cart?.main_cart_items?.some(isActiveItem);

const hasCartItems = hasPetItems || hasHdItems;

  return (
    <div className=" ml-[63px] font-roboto mr-[58px]">

      <div className="flex justify-between items-center mt-[30px]">
        <h1 className="text-[32px] font-medium mb-5">Hello Pet Parent!</h1>
       {location? <p className="flex items-start text-[18px] font-medium max-w-[40%]">
         <span className="bg-[#FFDAE0] text-[#F05B72] px-[7px] py-[5px] text-[16px] font-medium rounded-tl-[20px] rounded-br-[20px] whitespace-nowrap mr-[10px]">
                      Delivery in 2 hours
                    </span>
          <FaLocationDot className="shrink-0 mt-1 mr-[2px]"/>
          <span className="line-clamp-2">{location}</span>
        </p>: ""}
      </div>
      
{hasCartItems?
      <div
        className="max-h-[calc(var(--mirror-frame-height,100vh)-340px)] overflow-y-auto"
        ref={scrollRef}
        data-mirror-cart-scroll="true"
      >
      {carts.map((cart, i) => (
        <BillingMirrorCart
          key={i}
          cart={cart}
          showColumnHeaders={i === 0}
          petSpecies={cart.pet_species}
          hasMembership={hasMembership}
        />
      ))}
    </div> : <NoCartDataFound/>}
    </div>
  );
};

export default BillingMirrorItems;
